import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-liste-carico-ingiunzioni',
	templateUrl: './liste-carico-ingiunzioni.component.html',
	styleUrls: ['./liste-carico-ingiunzioni.component.css']
})
export class ListeCaricoIngiunzioniComponent implements OnInit {

	headerFields = [
		{
			label: "Destinatario",
			code: "destinatario",
			class: "tab-cell-8"
		},
		{
			label: "Indirizzo Completo",
			code: "indirizzo_completo",
			class: "tab-cell-8"
		},
		{
			label: "Dovuto",
			code: "dovuto",
			class: "tab-cell-8"
		},
		{
			label: "PreSpesDirNot",
			code: "pre_spes_dir_not",
			class: "tab-cell-8"
		},
		{
			label: "PreInteressi",
			code: "pre_interessi",
			class: "tab-cell-8"
		},
		{
			label: "PreSanzioni",
			code: "pre_sanzioni",
			class: "tab-cell-8"
		},
		{
			label: "Inter.Coatt",
			code: "inter_coatt",
			class: "tab-cell-8"
		},
		{
			label: "On.Risc.",
			code: "on_risc",
			class: "tab-cell-8"
		},
		{
			label: "SpNotCoatt",
			code: "sp_not_coatt",
			class: "tab-cell-8"
		},
		{
			label: "Totale",
			code: "totale",
			class: "tab-cell-8"
		},
		{
			label: "idSoggetto",
			code: "id_sogg",
			class: "tab-cell-8"
		},
		{
			label: "CF/CU",
			code: "cf_cu",
			class: "tab-cell-8"
		}
	];

	rowFields : any[] = [
		{
			"destinatario" : "",
			"indirizzo_completo" : "",
			"dovuto" : "",
			"pre_spes_dir_not" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"inter_coatt" : "",
			"on_risc" : "",
			"sp_not_coatt" : "",
			"totale" : "",
			"id_sogg" : "",
			"cf_cu" : ""
		},
		{
			"destinatario" : "",
			"indirizzo_completo" : "",
			"dovuto" : "",
			"pre_spes_dir_not" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"inter_coatt" : "",
			"on_risc" : "",
			"sp_not_coatt" : "",
			"totale" : "",
			"id_sogg" : "",
			"cf_cu" : ""
		},
		{
			"destinatario" : "",
			"indirizzo_completo" : "",
			"dovuto" : "",
			"pre_spes_dir_not" : "",
			"pre_interessi" : "",
			"pre_sanzioni" : "",
			"inter_coatt" : "",
			"on_risc" : "",
			"sp_not_coatt" : "",
			"totale" : "",
			"id_sogg" : "",
			"cf_cu" : ""
		}
	]

	constructor() { }

	ngOnInit() {
	}

}
